import React from "react";
import { Container, Row, Col } from "react-bootstrap";

import {
  FaAngleDoubleRight,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope,
  FaFacebookF,
  FaLinkedinIn,
  FaInstagram, 
} from "react-icons/fa";
import { FaWhatsapp } from "react-icons/fa6";

import { Link } from "react-router-dom";
import logo from "../../assets/ngo-logo-fottor.png";

import "./Footer.css";

const Footer = () => {
  return (
    <footer className="footer-section text-white">
      <div className="footer-overlay">
        <Container fluid>
          <Row className="py-5">
            {/* About */}
            <Col md={3} sm={6} className="mb-4">
              <h5 className="footer-title">About Us</h5>
              <div className="footer-logo mb-3">
                <img
                  src={logo}
                  alt="Digisphere Logo"
                  style={{ width: "150px", height: "auto" }}
                />
              </div>
              <p className="footer-text">
             Key Relief Foundation is dedicated to bringing positive change through education, empowerment, and enrichment programs for underprivileged communities.
              </p>
            </Col>

            {/* Helpful Links */}
            <Col md={3} sm={6} className="mb-4">
              <h5 className="footer-title">Helpful Links</h5>
              <ul className="footer-links">
                {[
                  { label: "Home", href: "/" },
                  { label: "About Us", href: "/about" },
                  { label: "Our Programs", href: "/our-programs" },
                  { label: "Member Login", href: "/member" },
                  { label: "Contact Us", href: "/contact" },
                  { label: "Donate", href: "/donate" },
                ].map((link, i) => (
                  <li key={i}>
                    <FaAngleDoubleRight className="footer-icon" />
                    <a href={link.href}>{link.label}</a>
                  </li>
                ))}
              </ul>
            </Col>

            {/* Services */}
            <Col md={3} sm={6} className="mb-4">
              <h5 className="footer-title">Our Services</h5>
              <ul className="footer-links">
                {[
                  { label: "Enrichment", to: "/our-programs#enrichment" },
                  { label: "Education", to: "/our-programs#education" },
                  { label: "Empowerment", to: "/our-programs#empowerment" },
                  {
                    label: "Impact Stories",
                    to: "/our-programs#impact-stories",
                  },
                ].map((item, i) => (
                  <li key={i}>
                    <FaAngleDoubleRight className="footer-icon" />
                    <Link to={item.to}>{item.label}</Link>
                  </li>
                ))}
              </ul>
            </Col>

            {/* Contact */}
            <Col md={3} sm={6}>
              <h5 className="footer-title">Contact Us</h5>
              <ul className="footer-contact">
                <li>
                  <FaMapMarkerAlt className="footer-icon" />
                  <span>
                    Key Relief Foundation
                    <br />
                    Full Address Here
                  </span>
                </li>
                <li>
                  <FaPhoneAlt className="footer-icon" />
                  <a href="tel:+919999888822">+91-9999-8888-22</a>
                </li>
                <li>
                  <FaEnvelope className="footer-icon" />
                  <a href="mailto:contact@keyrelief.org">
                    contact@keyrelief.org
                  </a>
                </li>
              </ul>
              <div className="footer-social mt-3">
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaFacebookF />
                </a>
                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaLinkedinIn />
                </a>
                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaWhatsapp />
                </a>
                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaInstagram />
                </a>
              </div>
            </Col>
          </Row>

          <Row className="border-top pt-3">
            <Col className="text-center">
              <small>
                © All Rights Reserved By{" "}
                <a
                  href="https://digispheretech.in/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="digisphere"
                >
                  Digisphere
                </a>
              </small>
            </Col>
          </Row>
        </Container>
      </div>
    </footer>
  );
};

export default Footer;
